<template>
    <div class="companies" v-if="['super_admin'].includes(user.role)">
        <v-data-table
            :headers="headers"
            :items="companies"
            :items-per-page="20"
            class="elevation-1 bg-grey-lighten-3"
            :loading="loading"
            item-key="id"
            loading-text="Loading companies"
            :page="tableOptions && tableOptions.page ? tableOptions.page : 1"
            :options.sync="options"
            :footer-props="footerProps"
            :server-items-length="companiesCount"
        >
            <template v-slot:item.has_prediction_rights="{ item }">
                <div class="flex align-center justify-center" style="width: 100%; display: flex">
                    <v-checkbox
                        dense
                        hide-details
                        :ripple="false"
                        class="pt-0"
                        v-model="item.has_prediction_rights"
                        @change="handleHasPredictionRightsCheckboxToggle(item)"
                    />
                </div>
            </template>

            <template v-slot:item.edit="{ item }">
                <v-btn
                    :to="{name: 'company-view', params: {id: item.id}}"
                    color="primary"
                    icon
                >
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'CompaniesList',
    data() {
        return {
            footerProps: {'items-per-page-options': [20, 50, 100, 500]},
            options: this.tableOptions,
            expanded: [],
            selectedStationLocationIdx: null,
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Client nrs',
                    align: 'start',
                    sortable: false,
                    value: 'client_nrs',
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'value',
                },
                {
                    text: 'Has predictions rights',
                    align: 'center',
                    sortable: false,
                    value: 'has_prediction_rights',
                },
                {
                    text: 'Station locations',
                    align: 'center',
                    sortable: false,
                    value: 'station_location_count',
                },
                {
                    text: '',
                    align: 'end',
                    sortable: false,
                    value: 'edit',
                },
            ],
        };
    },
    computed: {
        ...mapState('company', ['companies', 'copyOfCompanies', 'companiesCount', 'loading', 'tableOptions']),
        ...mapState('auth', ['user']),
    },
    watch: {
        options(val) {
            this.setTableOptions(val);
        },
    },
    methods: {
        ...mapMutations('company', ['setTableOptions']),
        ...mapActions('company', ['toggleCompanyHasPredictionRights', 'editCompanyField']),
        async handleHasPredictionRightsCheckboxToggle(item) {
            await this.toggleCompanyHasPredictionRights({itemId: item.id, value: item.has_prediction_rights});
        },
    },
};
</script>

<style scoped>
.bg-grey-lighten-3 {
    background-color: #FAFAFA;
    border-radius: 0;
}
</style>